export default __webpack_public_path__ + "static/media/transactions.008dcd6f.svg";